<template>
  <div class="plat-log-container">
    <header>
      <span class="title">操作日志</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
      </div>
    </header>

    <div class="log-box">
      <!-- <div class="log-item">
        <div class="line">
          <div class="circle"></div>
        </div>
        <div class="rihgt">
          <div class="time"><span class="module">正式客户</span>2018-02-02 07:09</div>
          <div class="panel">
            <div class="field">
              <span class="field-title">客户名称：</span>深圳汇聚华企科技有限公司
            </div>
            <div class="content">
              帅胜余添加账号“帅胜余”。
            </div>
          </div>
        </div>
      </div> -->
      <div class="log-item" v-for="(date, index) in tableList" :key="index">
        <div class="line">
          <div class="circle"></div>
        </div>
        <div class="rihgt">
          <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
          <div class="content">{{date.content}}</div>
        </div>
      </div>
    </div>

    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
export default {
  data () {
    return {
      defaultMsg: '<b>操作日志</b>',
      searchInput: '',
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      disabled: true,
      tableList: []
    }
  },
  mounted () {
    this.searchValue = ''
    this.queryApplicationList()
  },
  methods: {
    /** 获取列表 */
    queryApplicationList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryRecordList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryApplicationList()
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryApplicationList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryApplicationList()
    }
  }
}
</script>

<style scoped lang="scss">
.plat-log-container{
  .log-box{
    padding: 30px;
    height: calc(100% - 120px);
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/platform/plat-log.vue